import cls from 'classnames';
import React, { PureComponent } from 'react';
import { withContentRect } from 'react-measure';
import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { g as getRandomValue, P as POLL_IMAGES_POOL } from '../../defaults-0542c304.js';
import { withRCEHelpers, RCEHelpersPropTypes } from '../rce-helpers-context/index.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { ImageUploadPropTypes } from './types.js';
import { LoaderIcon } from '../../assets/icons/LoaderIcon.js';
import { ReplaceIcon } from '../../assets/icons/ReplaceIcon.js';
import 'prop-types';

var css_248z = ".RqSrD{height:100%;overflow:hidden;position:relative;width:100%;z-index:1}[dir] .RqSrD{background-position:50%;background-repeat:no-repeat;background-size:cover}.RqSrD:not(._8Y7BM) .DCgJi{z-index:2}[dir] .RqSrD:not(._8Y7BM) .DCgJi{cursor:pointer}.RqSrD:not(._8Y7BM):focus .ebIHe,.RqSrD:not(._8Y7BM):hover .ebIHe{opacity:1}.DCgJi,.ebIHe{height:100%;opacity:0;position:absolute;top:0;width:100%}.ebIHe{align-items:center;display:flex;flex-direction:row;justify-content:center;transition:opacity .5s}[dir] .ebIHe{background:rgba(0,0,0,.5)}.ebIHe ._7AHUD{font-size:16px}[dir] .ebIHe ._7AHUD{margin:0 10px}.gwuAX{opacity:1}.SOY8l{display:none}.vlLal{animation-duration:1.5s;animation-iteration-count:infinite;animation-name:Z4U0m;animation-timing-function:linear}@keyframes Z4U0m{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var styles = {"container":"RqSrD","disabled":"_8Y7BM","imageInput":"DCgJi","overlay":"ebIHe","text":"_7AHUD","shown":"gwuAX","hide":"SOY8l","spinner":"vlLal","spin":"Z4U0m"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ImageUploadComponent extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      value: this.props.value || getRandomValue(POLL_IMAGES_POOL),
      backgroundImage: null,
      loading: false
    });
    __publicField(this, "$label", React.createRef());
    __publicField(this, "handleFileUpload", ({ data }) => {
      this.setState(
        {
          value: `https://static.wixstatic.com/media/${data.file_name}`,
          loading: false
        },
        () => {
          this.updateBackgroundImage();
          this.sync();
        }
      );
    });
    __publicField(this, "handleFileReadLoad", (backgroundImage, file) => {
      const { helpers } = this.props.rce;
      this.setState({ backgroundImage: `url(${backgroundImage})`, loading: false });
      if (helpers == null ? void 0 : helpers.handleFileUpload) {
        this.setState({ loading: true });
        helpers.handleFileUpload(file, this.handleFileUpload);
      }
    });
    __publicField(this, "handleInputChange", (e) => {
      this.handleFileChange(Array.from(e.target.files));
      e.target.value = null;
    });
    __publicField(this, "handleFileChange", ([file]) => {
      const reader = new FileReader();
      this.setState({ loading: true });
      reader.onload = (e) => this.handleFileReadLoad(e.target.result, file);
      reader.readAsDataURL(file);
    });
    __publicField(this, "handleKeyPress", (e) => {
      var _a;
      const enterOrSpace = e.key === "Enter" || e.key === " " || e.key === "Spacebar" || e.which === 13 || e.which === 32;
      if (enterOrSpace) {
        e.preventDefault();
        (_a = this.$label.current) == null ? void 0 : _a.click();
      }
    });
    __publicField(this, "handleFocus", (e) => {
      e.stopPropagation();
      const { rce } = this.props;
      rce.setInPluginEditingMode(true);
    });
    __publicField(this, "handleBlur", () => {
      const { rce } = this.props;
      rce.setInPluginEditingMode(false);
    });
  }
  componentWillReceiveProps(props) {
    const { value, contentRect } = props;
    const { value: prevValue, contentRect: prevContentRect } = this.props;
    if (value !== prevValue) {
      this.setState({ value }, () => this.updateBackgroundImage());
    }
    if (JSON.stringify(contentRect.bounds) !== JSON.stringify(prevContentRect.bounds)) {
      this.updateBackgroundImage(contentRect.bounds);
    }
  }
  sync() {
    this.props.onChange(this.state.value);
  }
  updateBackgroundImage(bounds = this.props.contentRect.bounds) {
    const { value } = this.state;
    if (!bounds.width || !bounds.height) {
      return null;
    }
    const backgroundImage = `url(${getScaleImageSrc(value, bounds.width, bounds.height)})`;
    this.setState(() => ({
      backgroundImage
    }));
  }
  render() {
    const { dataHook, className, rce, small, disabled, measureRef, style = {} } = this.props;
    const { loading, backgroundImage } = this.state;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: measureRef,
        className: cls(styles.container, className, {
          [styles.disabled]: rce.isViewMode || disabled
        }),
        style: __spreadProps(__spreadValues({}, style), { backgroundImage }),
        tabIndex: rce.isViewMode ? -1 : 0,
        "aria-hidden": rce.isViewMode,
        role: "button",
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress,
        "data-hook": dataHook
      },
      /* @__PURE__ */ React.createElement("label", { ref: this.$label }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "file",
          disabled: rce.isViewMode || disabled,
          onChange: this.handleInputChange,
          accept: "image/*",
          tabIndex: -1,
          className: styles.imageInput
        }
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles.overlay, {
            [styles.shown]: loading
          })
        },
        loading ? /* @__PURE__ */ React.createElement(
          LoaderIcon,
          {
            width: small ? 24 : 48,
            height: small ? 24 : 48,
            className: styles.spinner
          }
        ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReplaceIcon, null), /* @__PURE__ */ React.createElement(
          "p",
          {
            className: cls(styles.text, {
              [styles.hide]: small
            })
          },
          "Change Image"
        ))
      ))
    );
  }
}
__publicField(ImageUploadComponent, "propTypes", __spreadValues(__spreadValues({}, ImageUploadPropTypes), RCEHelpersPropTypes));
__publicField(ImageUploadComponent, "defaultProps", {
  imagesPool: [],
  disabled: false
});
const ImageUpload = withContentRect("bounds")(withRCEHelpers(ImageUploadComponent));

export { ImageUpload };
//# sourceMappingURL=ImageUpload.js.map
